import { IOffice } from "../interfaces/office.interface";

export const OFFICE_CODES: Array<IOffice> = [
  { "offCode": "B", "offName": "Bangalore", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "C", "offName": "Chicago", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "D", "offName": "Dubai", "offCurrency": "£", "offMotherOffice": "L" },
  { "offCode": "E", "offName": "Dusseldorf", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "G", "offName": "Hong Kong", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "H", "offName": "Home" },
  { "offCode": "I", "offName": "Shanghai", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "L", "offName": "London", "offCurrency": "£" },
  { "offCode": "M", "offName": "Mexico", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "N", "offName": "Santiago", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "P", "offName": "Sao Paulo", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "S", "offName": "Singapore", "offCurrency": "US$" },
  { "offCode": "T", "offName": "Tokyo", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "U", "offName": "Seoul", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "V", "offName": "Vilnius", "offCurrency": "US$", "offMotherOffice": "L" },
  { "offCode": "Y", "offName": "Sydney", "offCurrency": "US$", "offMotherOffice": "S" },
  { "offCode": "Z", "offName": "Cape Town", "offCurrency": "£", "offMotherOffice": "L" }
];